// Definição de endpoints da API
export const API_ENDPOINTS = {
    AUTH: {
        LOGIN: '/api/admin/login',
        LOGOUT: '/api/admin/logout',
        PROFILE: '/api/admin/profile',
        CHANGE_PASSWORD: '/api/admin/change-password',
        OLD_API_INIT_SESSION: '/api/auth/init-session',
    },
    DASHBOARD: {
        INDEX: '/api/admin/dashboard',
    },
    // Gerenciamento de Administradores
    ADMINS: {
        INDEX: '/api/admin',
        STORE: '/api/admin',
        SHOW: (id: number) => `/api/admin/${id}`,
        UPDATE: (id: number) => `/api/admin/${id}`,
        ACTIVATE: (id: number) => `/api/admin/${id}/activate`,
        DEACTIVATE: (id: number) => `/api/admin/${id}/deactivate`,
    },
    // Gerenciamento de Usuários Finais (Clientes)
    USERS: {
        INDEX: '/api/admin/users',
        STORE: '/api/admin/users',
        SHOW: (id: number) => `/api/admin/users/${id}`,
        UPDATE: (id: number) => `/api/admin/users/${id}`,
        ACTIVATE: (id: number) => `/api/admin/users/${id}/activate`,
        DEACTIVATE: (id: number) => `/api/admin/users/${id}/deactivate`,
    },
    // Gerenciamento de Clientes e seus Financeiros/Produtos
    CUSTOMERS: {
        INDEX: '/api/admin/customers',
        STORE: '/api/admin/customers',
        SHOW: (id: number | string) => `/api/admin/customers/${id}`,
        UPDATE: (id: number | string) => `/api/admin/customers/${id}`,
        ORDERS: (id: number | string) => `/api/admin/customers/${id}/orders`,
        PRODUCTS: (id: number | string) => `/api/admin/customers/${id}/products`,
        PENDING_COSTS: (id: number | string) => `/api/admin/customers/${id}/pending-costs`,
        PAY_PRODUCT: (id: number | string, productId: number | string) => `/api/admin/customers/${id}/products/${productId}/pay`,
        MAINTENANCE_COSTS: (id: number | string, productId: number | string) => `/api/admin/customers/${id}/products/${productId}/costs`,
        MAINTENANCE_COST: (id: number | string, productId: number | string, costId: number | string) => `/api/admin/customers/${id}/products/${productId}/costs/${costId}`,
        REFERRALS: (id: number | string) => `/api/admin/customers/${id}/referrals`,
        ADD_REFERRAL: (id: number | string) => `/api/admin/customers/${id}/referrals`,
        REMOVE_REFERRAL: (id: number | string, referredId: number | string) => `/api/admin/customers/${id}/referrals/${referredId}`,
        REFERRAL_PRODUCTS: (id: number | string, referredId: number | string) => `/api/admin/customers/${id}/referrals/${referredId}/products`,
        UPDATE_REFERRAL_DATES: (id: number | string, referredId: number | string) => `/api/admin/customers/${id}/referrals/${referredId}/dates`,
    },
    PAGES: {
        INDEX: '/api/pages', // Lista pública
        SHOW_PUBLIC: (slug: string) => `/api/page/${slug}`,
        // Rotas de Admin para Pages
        INDEX_ADMIN: '/api/admin/pages',
        STORE: '/api/admin/pages',
        UPDATE: (slug: string) => `/api/admin/pages/${slug}`,
        DESTROY: (slug: string) => `/api/admin/pages/${slug}`,
        RESTORE: (slug: string) => `/api/admin/pages/${slug}/restore`,
        SHOW_ADMIN: (slug: string) => `/api/admin/pages/${slug}`,
    },
    NAVIGATION: {
        INDEX: '/api/navigation',
        FOOTER: '/api/navigation/footer',
        CATEGORY_PRODUCTS: (categoryId: number) => `/api/navigation/category/${categoryId}/products`
    },
    // Products Endpoints
    PRODUCTS: {
        INDEX: '/api/admin/products',
        SHOW: (id: number) => `/api/admin/products/${id}`,
        CREATE: '/api/admin/products',
        UPDATE: (id: number) => `/api/admin/products/${id}`,
        DELETE: (id: number) => `/api/admin/products/${id}`,
    },
    CART: {
        INDEX: '/api/cart',
        DESTROY: (productId: string) => `/api/cart/destroy/${productId}`,
    },
    EMAIL: {
        SEND: '/api/email/send',
    },
    FEATURE_FLAGS: {
        INDEX: (name: string) => `/api/feature-flags/${name}`,
    },
    // Influencers Endpoints
    INFLUENCERS: {
        INDEX: '/api/admin/influencers',
        STORE: '/api/admin/influencers',
        SHOW: (id: number) => `/api/admin/influencers/${id}`,
        UPDATE: (id: number) => `/api/admin/influencers/${id}`,
        DELETE: (id: number) => `/api/admin/influencers/${id}`,
        TOGGLE: (id: number) => `/api/admin/influencers/${id}/toggle`,
        // Public route
        PUBLIC_INDEX: '/api/influencers',
        PUBLIC_SHOW: (slug: string) => `/api/influencers/${slug}`,
    },
    // Brands & Categories Endpoints
    BRANDS: {
        INDEX: '/api/admin/brands',
        LIST: '/api/admin/brands',
        STORE: '/api/admin/brands',
        UPDATE: (id: number) => `/api/admin/brands/${id}`,
        DELETE: (id: number) => `/api/admin/brands/${id}`,
    },
    CATEGORIES: {
        INDEX: '/api/admin/categories',
        LIST: '/api/admin/categories',
        STORE: '/api/admin/categories',
        UPDATE: (id: number) => `/api/admin/categories/${id}`,
        DELETE: (id: number) => `/api/admin/categories/${id}`,
    },
    SHIPPINGS: {
        INDEX: '/api/admin/shippings',
        LIST: '/api/admin/shippings',
        STORE: '/api/admin/shippings',
    },
    LISTS: {
        CUSTOMERS: '/api/admin/users',
    },
    COUPONS: {
        INDEX: '/api/admin/coupons',
        STORE: '/api/admin/coupons',
        SHOW: (id: number) => `/api/admin/coupons/${id}`,
        UPDATE: (id: number) => `/api/admin/coupons/${id}`,
        DELETE: (id: number) => `/api/admin/coupons/${id}`,
    },
};
